import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

class RowFourItem extends Component {
  constructor(props) {
    super(props)
    this.state = { ...props }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }
  render() {
    let data = this.state && this.state.data
    let id = this.state.index === 0
    let clear = this.state.index === 4 ? {clear: 'left', marginLeft: '0'} : {}
    const textAlign = (data && data.centeredText) ? 'center' : 'auto'

    return (
      <li className="grid-little" id={id && 'left-side'} style={clear}>
        <figure className="grid-small-block">
          <div className="aspectRatioPlaceholder">
            <div className="aspectRatioPlaceholder-fill"></div>
            <div className="imageWrapper">
              <img src={data.imageURL} />
            </div>
          </div>
          <figcaption className="">
            <h5 style={{marginTop: '2vmin', textAlign: textAlign}} className=""><b>{data && data.title}</b></h5>
            <h5 className="sectra-light" style={{marginBottom: (data && data.subSubTitle) ? 0 : '2vmin', textAlign: textAlign}}>{data && data.subTitle}</h5>
            <h5 className="sectra-light" style={{marginBottom: '2vmin', textAlign: textAlign}}>{data && data.subSubTitle}</h5>
            <p>{data && data.description}</p>
          </figcaption>
        </figure>

      </li>
    )
  }
}
RowFourItem.contextTypes = {
}
RowFourItem.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(RowFourItem)



// WEBPACK FOOTER //
// ./src/components/Utils/RowFourItem.js